export default "images/close-dialog.png";